import { ReactourStep } from 'reactour';
import { FirstStep } from './Components/FirstStep';
import { SecondStep } from './Components/SecondStep';
import { ThirdStep } from './Components/ThirdStep';
import { FourthStep } from './Components/FourthStep';

export type StepProps = {
  step: number;
  close: () => void;
  goTo: (step: number) => void;
};

export const steps: ReactourStep[] = [
  {
    selector: '.chatbot-item .navbar-dropdown',
    content: FirstStep,
    position: 'bottom',
  },
  {
    selector: '.inbox-item .top-level-sidebar-link',
    content: SecondStep,
    position: 'bottom',
  },
  {
    selector: '.campaigns-item .top-level-sidebar-link__title-text',
    content: ThirdStep,
    position: 'bottom',
  },
  {
    selector: '.active-page-dropdown__wrapper',
    content: FourthStep,
    position: 'bottom',
  },
  // Temporary disabled by product request
  // {
  //   selector: '.user-dropdown__link-area',
  //   content: FifthStep,
  //   position: 'bottom',
  // },
];
